import { gql } from "@apollo/client";

const MARK_ALL_MESSAGE_READ = gql`
  subscription MarkAllMessageChatRead {
    markallmessagechatread {
      agentId
      inboxId
      source
    }
  }
`;

export default MARK_ALL_MESSAGE_READ;
